import React, { useEffect } from 'react';
import ReportCard from 'containers/partials/cards/ReportCard';
import { generatePath, useParams } from 'react-router-dom';
import { ROUTE_PERSONS_ENTITY_PERSON_SESSIONS_SESSION } from 'routes/RouteList';
import { useEntityContext } from 'containers/pages/persons/store/useEntityContext';
import { useSessionContext } from 'contexts/SessionContext';
import { useTestDataContext } from 'contexts/TestDataContext';
import { useAbility } from '@casl/react';
import { AbilityContext } from 'Can';
import { useContextMenu } from 'contexts/ContextMenuProvider';
import DownloadReportsButton from 'containers/partials/session-report-buttons/DownloadReportsButton';
import Loader from 'components/loader/Loader';
import { LegacyReportCard } from 'containers/pages/sessions/SessionPersonReportTab';

const PersonSessionReportTab = () => {
  const { entityId, groupId, sessionId, personId } = useParams();
  const person = useEntityContext(s => s.person);
  const { session, options } = useSessionContext();
  const { testDataLoading, testData, hasCompletedIdoILike } =
    useTestDataContext();
  const ability = useAbility(AbilityContext);
  const { setMenuItems, clearAllContext } = useContextMenu();

  useEffect(() => {
    const contextButtons = [];

    if (
      testData &&
      ability.can('download-individual', 'Sessions') &&
      ((session.isIDoILike && hasCompletedIdoILike()) || !session.isIDoILike)
    ) {
      contextButtons.push(
        <DownloadReportsButton
          session={session}
          testData={testData}
          person={person}
          options={options}
          type={'individual'}
        />
      );
    }

    setMenuItems(contextButtons);
    return () => {
      // Cleanup action buttons and context menu items
      clearAllContext();
    };
  }, [session, testData, sessionId, personId, ability, hasCompletedIdoILike]);

  if (testDataLoading) {
    return <Loader />;
  }

  if (session.isTestSetV2 || session.isIDo) {
    return (
      <ReportCard
        compressed
        rootPath={generatePath(ROUTE_PERSONS_ENTITY_PERSON_SESSIONS_SESSION, {
          entityId,
          groupId,
          sessionId,
          personId
        })}
      />
    );
  } else {
    return (
      <LegacyReportCard
        type={session.config.type}
        subtype={session.config.subtype}
      />
    );
  }
};

export default PersonSessionReportTab;
